import { toast } from "react-toastify";
import { axiosInstance, axiosInstanceAuth } from "../../Utils/AxiosInstance";

export const GetAllProject = (data) => {
  return {
    type: "get_allproject",
    payload: data,
    loader: false,
  };
};
export function getallProject() {
  return async (dispatch) => {
    try {
      const url = "Projects/GetAll";

      const result = await axiosInstance.get(url);

      if (result.data.IsSuccess === true) {
        dispatch(GetAllProject(result.data.Data));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}

export const GetAllCRMProject = (data) => {
  return {
    type: "get_allcrmproject",
    payload: data,
    loader: false,
  };
};
export function getallCRMProject() {
  return async (dispatch) => {
    try {
      const url = "Users/GetCrmProjects";

      const result = await axiosInstanceAuth.get(url);

      if (result?.data?.IsSuccess === true) {
        dispatch(GetAllCRMProject(result?.data?.Data));
      } else {
        toast.error(result?.data?.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}

export const GetAllProjectSearch = (data) => {
  return {
    type: "get_allprojectsearch",
    payload: data,
    loader: false,
  };
};
export function getallProjectSearch(isOwn) {
  return async (dispatch) => {
    try {
      const url = isOwn
        ? `Projects/GetProjectForPopulate?isOwn=${isOwn}`
        : "Projects/GetProjectForPopulate";

      const result = await axiosInstance.get(url);

      if (result.data.IsSuccess === true) {
        dispatch(GetAllProjectSearch(result.data.Data));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}
